<div class="w-100 d-flex align-items-center justify-content-center flex-column flex-md-row pt-4 pb-2 text-center">
  <div class="container-fluid">
    <p class="col-12 text__white" [innerHTML]="'app.footer.text' | translate"></p>
  </div>
</div>
